import React from "react";
import { DuplicateProductFormValues } from "./types";

export type DuplicateProductFormContextType = {
  handleOnSubmit: (values: DuplicateProductFormValues) => Promise<void>;
};

export const DuplicateProductFormContext = React.createContext<
  DuplicateProductFormContextType | undefined
>(undefined);
